export const CONFIG_KEYS_REQUEST = 'CONFIG_KEYS_REQUEST';
export const CONFIG_KEYS_SUCCESS = 'CONFIG_KEYS_SUCCESS';
export const CONFIG_KEYS_FAILURE = 'CONFIG_KEYS_FAILURE';

export const CONFIGS_REQUEST = 'CONFIGS_REQUEST';
export const CONFIGS_SUCCESS = 'CONFIGS_SUCCESS';
export const CONFIGS_FAILURE = 'CONFIGS_FAILURE';

export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const ADD_CONFIG = 'ADD_CONFIG';
export const DELETE_CONFIG = 'DELETE_CONFIG';
export const COPY_CONFIG = 'COPY_CONFIG';

export const ADD_CONSTRAINT = 'ADD_CONSTRAINT';
export const DELETE_CONSTRAINT = 'DELETE_CONSTRAINT';

export const CONFIGS_SAVE_REQUEST = 'CONFIGS_SAVE_REQUEST';
export const CONFIGS_SAVE_SUCCESS = 'CONFIGS_SAVE_SUCCESS';
export const CONFIGS_SAVE_FAILURE = 'CONFIGS_SAVE_FAILURE';

export const ACTIVE_CONFIG_REQUEST = 'ACTIVE_CONFIG_REQUEST';
export const ACTIVE_CONFIG_SUCCESS = 'ACTIVE_CONFIG_SUCCESS';
export const ACTIVE_CONFIG_FAILURE = 'ACTIVE_CONFIG_FAILURE';

export const ACTIVATE_CONFIG_REQUEST = 'ACTIVETE_CONFIG_REQUEST';
export const ACTIVATE_CONFIG_SUCCESS = 'ACTIVETE_CONFIG_SUCCESS';
export const ACTIVATE_CONFIG_FAILURE = 'ACTIVETE_CONFIG_FAILURE';

function configKeysRequest() {
  return {
    type: CONFIG_KEYS_REQUEST,
  };
}

function configKeysFailure(error) {
  return {
    type: CONFIG_KEYS_FAILURE,
    payload: { error },
  };
}

function configKeysSuccess(keys) {
  return {
    type: CONFIG_KEYS_SUCCESS,
    payload: { keys },
  };
}

export function readConfigKeys() {
  return dispatch => {
    dispatch(configKeysRequest());

    return fetch('/api/configs', {
      credentials: 'include', // Make sure we send and receive any cookies
    })
      .then(
        response => {
          if (!response) {
            const error = new Error(response.statusText);
            error.status = response.status;
            throw error;
          }

          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            return response.json();
          }

          throw new Error('Invalid content type ' +
            response.headers.get('content-type'));
        },
        error => dispatch(configKeysFailure(error))
      )
      .then(
        keys => dispatch(configKeysSuccess(keys)),
        error => dispatch(configKeysFailure(error))
      );
  };
}

function configsRequest() {
  return {
    type: CONFIGS_REQUEST,
  };
}

function configsFailure(key, error) {
  return {
    type: CONFIGS_FAILURE,
    payload: { key, error },
  };
}

function configsSuccess(key, configs) {
  return {
    type: CONFIGS_SUCCESS,
    payload: { key, configs },
  };
}

export function readConfigs(key) {
  return dispatch => {
    dispatch(configsRequest());

    return fetch(`/api/configs/${ key }`, {
      credentials: 'include', // Make sure we send and receive any cookies
    })
      .then(
        response => {
          if (!response) {
            const error = new Error(response.statusText);
            error.status = response.status;
            throw error;
          }

          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            return response.json();
          }

          throw new Error('Invalid content type ' +
            response.headers.get('content-type'));
        },
        error => dispatch(configKeysFailure(key, error))
      )
      .then(
        configs => dispatch(configsSuccess(key, configs)),
        error => dispatch(configsFailure(key, error))
      );
  };
}

export function updateConfig(key, index, config) {
  return {
    type: UPDATE_CONFIG,
    payload: { key, index, config },
  };
}

function configsSaveRequest(key) {
  return {
    type: CONFIGS_SAVE_REQUEST,
    payload: { key },
  };
}

function configsSaveFailure(key, error) {
  return {
    type: CONFIGS_SAVE_FAILURE,
    payload: { key, error },
  };
}

function configsSaveSuccess(key, items, sendDate) {
  return {
    type: CONFIGS_SAVE_SUCCESS,
    payload: { key, items, sendDate },
  };
}

export function saveConfigs(key, items, sendDate) {
  return (dispatch, getState) => {
    dispatch(configsSaveRequest(key));

    // Do not use catch, because that will also catch any errors in the dispatch
    // and resulting render, causing an loop of 'Unexpected batch number'
    // errors. See https://github.com/facebook/react/issues/6895
    return fetch(`/api/configs/${ key }`, {
      headers: { 'Content-Type': 'application/json' },
      method: 'PUT',
      body: JSON.stringify({items, sendDate}),
      credentials: 'include', // Make sure we send and receive any cookies
    })
      .then(
        response => {
          if (!response.ok) {
            const error = new Error(response.statusText);
            error.status = response.status;
            throw error;
          }

          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            return response.json();
          }

          throw new Error('Invalid content type ' +
            response.headers.get('content-type'));
        },
        error => dispatch(configsSaveFailure(key, error))
      )
      .then(
        () => {
          // Update key list if needed, ie. if copying or creating new configs
          const { configs } = getState();
          if (configs.allKeys.indexOf(key) < 0) {
            dispatch(configKeysSuccess([ ...configs.allKeys, key ]));
          }

          return dispatch(configsSaveSuccess(key, items, sendDate));
        },
        error => dispatch(configsSaveFailure(key, error))
      );
  };
}

export function addConfig(key, slot) {
  return {
    type: ADD_CONFIG,
    payload: { key, slot },
  };
}

export function deleteConfig(key, index) {
  return {
    type: DELETE_CONFIG,
    payload: { key, index },
  };
}

export function copyConfig(key, config) {
  return {
    type: COPY_CONFIG,
    payload: { key, config },
  };
}

function activateConfigRequest() {
  return {
    type: ACTIVATE_CONFIG_REQUEST,
  };
}

function activateConfigFailure(error) {
  return {
    type: ACTIVATE_CONFIG_FAILURE,
    payload: { error },
  };
}

function activateConfigSuccess(key) {
  return {
    type: ACTIVATE_CONFIG_SUCCESS,
    payload: { key },
  };
}

export function activateConfig(key) {
  return dispatch => {
    dispatch(activateConfigRequest(key));

    // Do not use catch, because that will also catch any errors in the dispatch
    // and resulting render, causing an loop of 'Unexpected batch number'
    // errors. See https://github.com/facebook/react/issues/6895
    return fetch('/api/active', {
      headers: { 'Content-Type': 'application/json' },
      method: 'PUT',
      body: JSON.stringify({ key }),
      credentials: 'include', // Make sure we send and receive any cookies
    })
      .then(
        response => {
          if (!response.ok) {
            const error = new Error(response.statusText);
            error.status = response.status;
            throw error;
          }

          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            return response.json();
          }

          throw new Error('Invalid content type ' +
            response.headers.get('content-type'));
        },
        error => dispatch(activateConfigFailure(error))
      )
      .then(
        () => dispatch(activateConfigSuccess(key)),
        error => dispatch(activateConfigFailure(error))
      );
  };
}

function activeConfigRequest() {
  return {
    type: ACTIVE_CONFIG_REQUEST,
  };
}

function activeConfigFailure(error) {
  return {
    type: ACTIVE_CONFIG_FAILURE,
    payload: { error },
  };
}

function activeConfigSuccess(key) {
  return {
    type: ACTIVE_CONFIG_SUCCESS,
    payload: { key },
  };
}

export function readActiveConfig() {
  return (dispatch) => {
    dispatch(activeConfigRequest());

    return fetch('/api/active', {
      credentials: 'include', // Make sure we send and receive any cookies
    })
      .then(
        response => {
          if (!response) {
            const error = new Error(response.statusText);
            error.status = response.status;
            throw error;
          }

          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            return response.json();
          }

          throw new Error('Invalid content type ' +
            response.headers.get('content-type'));
        },
        error => dispatch(activeConfigFailure(error))
      )
      .then(
        data => dispatch(activeConfigSuccess(data.key)),
        error => dispatch(activeConfigSuccess(error))
      );
  };
}

export function addConstraint(key, index, row, constraint) {
  return {
    type: ADD_CONSTRAINT,
    payload: { key, index, row, constraint },
  };
}

export function deleteConstraint(key, index, row, column) {
  return {
    type: DELETE_CONSTRAINT,
    payload: { key, index, row, column },
  };
}



// WEBPACK FOOTER //
// ./client/src/actions/configs.js